/**
 * /collections drill-down (sections/main-collections-menu.liquid).
 *
 * Levels are pre-rendered panels; this only toggles which one is visible and keeps
 * the open panel in the URL hash (#apparel, #apparel/women) so the browser back
 * button, reloads and shared links land on the right level.
 */
if (!customElements.get('collections-menu')) {
  class CollectionsMenu extends HTMLElement {
    constructor() {
      super();
      this.levels = Array.from(this.querySelectorAll('.collections-menu__level'));
      this.byKey = new Map(this.levels.map((el) => [el.dataset.key, el]));
      this.addEventListener('click', this.handleClick.bind(this));
      window.addEventListener('hashchange', () => this.showFromHash(false));
      this.showFromHash(false);
    }

    handleClick(evt) {
      // Only real user activation (mouse, touch, keyboard) opens a level; a synthetic
      // click from another script must not change the view or the URL.
      if (!evt.isTrusted) return;
      const opener = evt.target.closest('[data-open]');
      if (opener) {
        evt.preventDefault();
        this.show(opener.dataset.open, true);
        return;
      }
      const back = evt.target.closest('[data-back]');
      if (back) {
        evt.preventDefault();
        const current = back.closest('.collections-menu__level');
        const key = current.dataset.key;
        const parent = key.includes('/') ? key.slice(0, key.lastIndexOf('/')) : '';
        this.show(parent, true);
      }
    }

    showFromHash(focus) {
      const key = decodeURIComponent(window.location.hash.replace(/^#/, ''));
      this.show(this.byKey.has(key) ? key : '', false, focus);
    }

    /**
     * @param {string} key - '' for level 1, 'apparel', 'apparel/women'
     * @param {boolean} pushHash - write the key to the URL (user action) or not (hashchange)
     * @param {boolean} [focus=true]
     */
    show(key, pushHash, focus = true) {
      const target = this.byKey.get(key) || this.byKey.get('');
      if (!target) return;

      this.levels.forEach((el) => {
        const active = el === target;
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      this.querySelectorAll('[data-open]').forEach((btn) => {
        btn.setAttribute('aria-expanded', btn.dataset.open === key ? 'true' : 'false');
      });

      if (pushHash) {
        const url = key ? `#${key}` : window.location.pathname + window.location.search;
        history.pushState(null, '', url);
      }

      if (focus) {
        const first = target.querySelector('[data-back], a, button');
        if (first) first.focus({ preventScroll: true });
      }
      const top = this.getBoundingClientRect().top + window.scrollY - 100;
      if (window.scrollY > top) window.scrollTo({ top, behavior: 'instant' });
    }
  }

  customElements.define('collections-menu', CollectionsMenu);
}
